import Icon from '../components/Icon.vue'

Icon.register({"wifi":{"width":640,"height":512,"paths":[{"d":"M384 416C384 451.3 355.3 480 320 480S256 451.3 256 416C256 380.7 284.7 352 320 352S384 380.7 384 416zM520.7 291.6C527.1 285.1 526.9 274.5 520.1 268.4 406.3 166.4 233.6 166.5 119.9 268.4 113.1 274.5 112.9 285.1 119.3 291.6L153.3 325.6C159.3 331.5 168.8 331.9 175.1 326.4 258 253.8 382.2 253.9 464.9 326.4 471.2 331.9 480.7 331.5 486.7 325.6L520.7 291.6zM632.8 177.8C639.2 171.5 639 161 632.4 154.9 456.7-9 183.3-8.9 7.6 154.9 1 161 0.8 171.5 7.2 177.8L41.2 211.8C47.3 217.9 57.1 218 63.4 212.2 208.2 78.5 431.8 78.5 576.6 212.2 582.9 218 592.7 217.9 598.8 211.8L632.8 177.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/wifi.js
// module id = null
// module chunks = 